;(function (angular) {
   'use strict'

   angular.module('internalWebsiteApp').filter('deliveryExclusionRangeDisplay', deliveryExclusionRangeDisplayFilter)

   /**
    * Angular filter factory function for formatting delivery exclusion time ranges
    *
    * @description Creates a filter that formats exclusion range objects into a human-readable
    * display string. The filter converts day names to abbreviations and time values from
    * 24-hour format to 12-hour AM/PM format.
    *
    * @returns {Function} The filter function that accepts an exclusionRange object
    *
    * @example
    * // In a template:
    * // {{ exclusionRange | deliveryExclusionRangeDisplay }}
    *
    * // In JavaScript:
    * var filter = deliveryExclusionRangeDisplayFilter();
    * var result = filter({ day: 'monday', startTime: '04:00', endTime: '20:00' });
    * // Returns: "Mon 4:00 AM – 8:00 PM"
    *
    * @since Added for drop exclusions feature
    */
   function deliveryExclusionRangeDisplayFilter() {
      /**
       * Formats a delivery exclusion range object into a display string
       *
       * @param {Object} exclusionRange - The exclusion range object to format
       * @param {string} exclusionRange.day - Day of the week (e.g., 'monday', 'tuesday')
       * @param {string} exclusionRange.startTime - Start time in 24-hour format (e.g., '04:00')
       * @param {string} exclusionRange.endTime - End time in 24-hour format (e.g., '20:00')
       *
       * @returns {string} Formatted display string (e.g., "Mon 4:00 AM – 8:00 PM") or empty string if invalid
       *
       * @example
       * // Valid input
       * filter({ day: 'wednesday', startTime: '09:30', endTime: '17:45' })
       * // Returns: "Wed 9:30 AM – 5:45 PM"
       *
       * // Invalid input
       * filter(null) // Returns: ""
       * filter({}) // Returns: ""
       */
      return function (exclusionRange) {
         if (!exclusionRange) {
            return ''
         }

         const {day, startTime, endTime} = exclusionRange

         if (!day || !startTime || !endTime) {
            return '' // return empty if missing required fields
         }

         // Example format:
         // { id: 1, day: 'monday', start: '04:00', end: '20:00' }

         function formatTime(time) {
            const [hours, minutes] = time.split(':')
            const hour24 = parseInt(hours, 10)
            const amOrPm = hour24 >= 12 ? 'PM' : 'AM'
            const displayHour = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24
            return `${displayHour}:${minutes} ${amOrPm}`
         }

         function formatDay(day) {
            const dayMap = {
               monday: 'Mon',
               tuesday: 'Tue',
               wednesday: 'Wed',
               thursday: 'Thu',
               friday: 'Fri',
               saturday: 'Sat',
               sunday: 'Sun',
            }
            return dayMap[day.toLowerCase()] || day
         }

         const formattedDay = formatDay(day)
         const formattedStart = formatTime(startTime)
         const formattedEnd = formatTime(endTime)

         return `${formattedDay} ${formattedStart} – ${formattedEnd}`
      }
   }
})(angular)
